import type { PopoverContentContext, PopoverContext } from '#types/components/base/popover'
import type { InjectionKey } from 'vue'

export const PopoverContextKey: InjectionKey<PopoverContext> = Symbol('PopoverContext')
export const PopoverContentContextKey: InjectionKey<PopoverContentContext> = Symbol('PopoverContentContext')
